import { List, SwipeableDrawer, styled } from '@mui/material';
import { FC, useState } from 'react';

import { useActions } from '../../hooks/useActions';

// Кастомный стиль
const CssSwipeableDrawer = styled(SwipeableDrawer)({
  '& .MuiPaper-root': {
    borderRadius: '8px',
  },
  '& .MuiAccordionSummary-root.Mui-expanded': {
    minHeight: 40,
  },
  '& .MuiAccordionSummary-content.Mui-expanded': {
    margin: 0,
  },
  '& .MuiBackdrop-root': {
    background: 'rgba(0, 0, 0, 0.3)',
  },
});

interface IDrawerProps {
  children?: any;
  position?: 'bottom' | 'left' | 'right' | 'top' | undefined;
  visible: boolean;
}

export const Drawer: FC<IDrawerProps> = ({ children, position, visible }) => {
  const { setVisibleInnerReview } = useActions();
  const openMenuDialog = () => setVisibleInnerReview(visible);
  const closeMenuDialog = () => setVisibleInnerReview(!visible);

  return (
    <CssSwipeableDrawer
      anchor={position}
      open={visible}
      onClose={closeMenuDialog}
      onOpen={openMenuDialog}
      variant="temporary"
    >
      {children}
    </CssSwipeableDrawer>
  );
};
